import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 6, // data considered stale after 6 hours
      gcTime: 1000 * 60 * 60 * 6, // data will be in cache for 6 hours (renamed from cacheTime)
      retry: (failureCount, error) => {
        // Only retry for network errors or 5xx server errors, not for 4xx client errors
        if (failureCount >= 3) return false; // Stop after 3 attempts

        // Don't retry on 4xx errors (client errors) — includes 429 Too Many Requests
        const status =
          (error as any)?.response?.status ?? (error as any)?.status;
        if (status && status >= 400 && status < 500) return false;

        return true; // Retry for other errors
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // exponential backoff
    },
    mutations: {
      retry: false,
    },
  },
});
